<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
 name: "HomeRow.vue"
}
</script>

<style scoped>
div {
  background-color: blue;
}
</style>